import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob, IJobType } from './jobs'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'
import { createTask_fill } from './taskFill'

const type: IJobType = 'fill-water'
export const register = () => registerJob(type, runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, type)

  let m = jobLogger.assertReserved(job)
  let mc = jobLogger.assertMachine(
    job,
    (c) => c.data.type === 'water-cooler' || c.data.type === 'grower',
  )

  if (jobLogger.runTasks(job)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  // 0 - fetch cargo
  if (job.stage === 0) {
    if (!m.carryingCargo || m.carryingCargo.data.type !== 'water') {
      jobLogger.addTask(
        job,
        createFetchCargoTask(mc.i, mc.j, null, 'water', true),
      )
      return
    }
    job.stage++
    return
  }
  // 1 - deliver cargo
  if (job.stage === 1) {
    jobLogger.addTask(
      job,
      createTask_deliverCargo(mc.i, mc.j, 'water', true, true),
    )
    job.stage++
    return
  }
  // 2 - consume cargo
  if (job.stage === 2) {
    jobLogger.addTask(job, createConsumeCargoTask(mc.i, mc.j, 'water', true))
    job.stage++
    return
  }

  // Apply fill effect
  if (job.stage === 3) {
    jobLogger.addTask(
      job,
      createTask_fill(mc.i, mc.j, (t) => {
        mc.waterSupply = 100
        jobLogger.succeedTask(job, t)
      }),
    )
    job.stage++
    return
  }

  jobLogger.succeedJob(job)
}
